"use client";
import React, { useEffect } from "react";
import "../styles/Engineeringdesign.css";
import Header from './Header';
import Footer from './Footer';
import Beams from "./Beams"; 
import EnggDesignHero from "./EnggDesignHero";

import image1 from "../assets/enggdesign3A.jpeg";
import image2 from "../assets/enggdesign2A.jpg";
import image3 from "../assets/enggdesign4A.avif";
import image4 from "../assets/enggdesign6A.jpeg";
import image5 from "../assets/enggdesign8A.webp";
import image6 from "../assets/enggdesign9A.webp";


import image7 from "../assets/enggdesign1A.png";
import image8 from "../assets/enggdesign5A.avif";
import image9 from "../assets/enggdesign7A.jpg";
import image10 from "../assets/enggdesign6A.jpeg";
import image11 from "../assets/enggdesign8A.webp";

const Engineeringdesign = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
    {
      title: "How we Achieve",
      image: image7,
      paragraph: {
        points: [
          "Computer Aided Design.",
          "Engineering Calculations.",
          "Standards Compliance Checks.",
          "A wide range of PC, Digitizers, Sophisticated Multifunction plotters and drafting facilities for high-quality output."
        ]
      }
    },
    {
      title: "How we Design",
      image: image8,
      paragraph: {
        points: [
          "AutoCAD.",
          "Bentley Microstation.",
          "Elecdes / Paneldes.",
          "CYMGRD Earthing design software.",
          "ETAP Protection Relay Coordination and Settings.",
          "ETABS Structural Design software.",
          "Microsoft VISIO PRO SNG OLP.",
          "SQL Single OLP NL.",
          "Primavera Project Management."
        ]
      }
    },
    {
      title: "Cutting-Edge Electrical Power System Design with CAD Tools",
      image: image9,
      paragraph: {
        text: "In the ever-evolving field of electrical engineering, the design, analysis, and maintenance of power systems play a crucial role in ensuring reliable and efficient energy distribution. By leveraging the capabilities of Computer-Aided Design (CAD) tools, engineers can create sophisticated and precise power system designs that meet the demands of modern industries and communities. CAD tools offer a wide array of features that facilitate the detailed planning and analysis of electrical systems, enabling engineers to visualize complex circuits, simulate various scenarios, and optimize performance.",
        points: [
          "Overall equipment layout for substations",
          "Block diagrams, single lines and intricate network designs",
          "Drawing review of substation equipment",
          "Earthing system design",
          "LV/MV/HV equipment and cable designs",
          "Sizing calculations CT & VT",
          "Modification works in existing Substations from LV to EHV",
          "Generators interface, MCC’s and process plants",
          "Fault analysis: load flow, short circuit calculation, etc."
        ]
      }
    },
    {
      title: "Comprehensive Power System Analysis",
      image: image10,
      paragraph: {
        text: "Our approach to power system design extends beyond initial creation; we conduct comprehensive power system analysis using advanced CAD tools. This analysis helps identify potential issues, optimize system performance, and ensure stability and reliability under various operating conditions. By simulating different scenarios and load conditions, we can predict system behavior and implement solutions that prevent disruptions and enhance efficiency."
      }
    },
    {
      title: "Maintenance and Sustainability",
      image: image11,
       paragraph: {
      text: "In the ever-evolving field of electrical engineering, the design, analysis, and maintenance of power systems play a crucial role in ensuring reliable and efficient energy distribution. By leveraging the capabilities of Computer-Aided Design (CAD) tools, engineers can create sophisticated and precise power system designs that meet the demands of modern industries and communities. CAD tools offer a wide array of features that facilitate the detailed planning and analysis of electrical systems, enabling engineers to visualize complex circuits, simulate various scenarios, and optimize performance.",
      points: [
        "Overall equipment layout for substations",
        "Block diagrams, single lines and intricate network designs",
        "Drawing review of substation equipment",
        "Earthing system design",
        "LV/MV/HV equipment and cable designs",
        "Sizing calculations CT & VT",
        "Modification works in existing Substations from LV to EHV",
        "Generators interface, MCC’s and process plants",
        "Fault analysis: load flow, short circuit calculation, etc."
      ]
    }
    }
  ];

  return (
    <>
      <Header />
      <div className="engineeringdesign-container">
        <div className="engineeringdesign-header">
          <h1>Engineering Design</h1>
          <p>
            "The primary goal of design is to ensure reliable and efficient power transmission and distribution"
            <br />
            Acume design and prepare intricate engineering drawings and calculations for substations ranging from 11 kV to 400 kV. The Design Department is made up of highly qualified and experienced engineers and design assistants who are well-versed in working in their respective fields using the following systems and software.
          </p>
        </div>

        {/* Cube Carousel */}
        <div className="engg-cube-wrapper">
          <div className="engg-cube-gallery">
            <img src={image1} alt="Engineering Slide 1" />
            <img src={image2} alt="Engineering Slide 2" />
            <img src={image3} alt="Engineering Slide 3" />
            <img src={image4} alt="Engineering Slide 4" />
            <img src={image5} alt="Engineering Slide 5" />
            <img src={image6} alt="Engineering Slide 6" />
          </div>
        </div>

        {/* Background animation */}
        <div className="eng-silk-bg">
           <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />

          
        </div>
      </div>

      <EnggDesignHero data={timelineData} />
      <Footer />
    </>
  );
};

export default Engineeringdesign;
